import React, { useState } from "react";
import { Link } from "react-router-dom";
import BG1 from "../../assets/blog/blog1.png";
import BG2 from "../../assets/blog/blog2.png";
import BG3 from "../../assets/blog/blog3.png";
import BG4 from "../../assets/blog/blog4.png";

import BG5 from "../../assets/blog/blog5.png";

import BG6 from "../../assets/blog/blog6.png";

import { Calender, Clock } from "../Icons";

const categories = [
  "All",
  "Science",
  "Technology",
  "Engineering",
  "Arts",
  "Mathematics",
];

const posts = [
  {
    id: 1,
    title: "Top 10 Python Projects for Beginners",
    date: "January 20, 2025",
    readTime: "8 min read",
    excerpt:
      "STEM is all about hands-on learning, problem-solving, and creativity. Discover the top 10 most fun coding projects for elementary students.",
    author: "Sarah Johnson",
    category: "Science",
    image: BG1,
  },
  {
    id: 2,
    title: "Top 10 Python Projects for Beginners",
    date: "January 18, 2025",
    readTime: "7 min read",
    excerpt:
      "Discover the top 10 most fun Python projects for Beginners and kids! Unleash your inner talent of coding through basic games, calculators, and interactive programs that make learning Python exciting.",
    author: "Michael Chen",
    category: "Science",
    image: BG2,
  },
  {
    id: 3,
    title: "Building Your First Robot: A Beginner's Guide",
    date: "January 15, 2025",
    readTime: "10 min read",
    excerpt:
      "Learn how to build your first robot with step-by-step instructions. Perfect for elementary students starting their robotics journey with hands-on projects and real-world applications.",
    author: "Emily Rodriguez",
    category: "Engineering",
    image: BG3,
  },
  {
    id: 4,
    title: "Building Your First Robot: A Beginner's Guide",
    date: "January 15, 2025",
    readTime: "10 min read",
    excerpt:
      "Learn how to build your first robot with step-by-step instructions. Perfect for elementary students starting their robotics journey with hands-on projects and real-world applications.",
    author: "Emily Rodriguez",
    category: "Engineering",
    image: BG3,
  },
  {
    id: 5,
    title: "The Role of Math in STEM Education",
    date: "January 12, 2025",
    readTime: "6 min read",
    excerpt:
      'When most kids hear the word Math, their first reaction is often, "Oh no!" But what if Math could be fun? Discover how mathematics powers everything in STEM and makes learning exciting.',
    author: "David Park",
    category: "Math",
    image: BG4,
  },

  {
    id: 6,
    title: "Fun After-School Activities for Kids",
    date: "January 10, 2025",
    readTime: "5 min read",
    excerpt:
      "The school day might end at 3 PM, but your child's curiosity doesn't stop there! Explore engaging after-school STEM activities that keep kids learning and having fun.",
    author: "Jessica Williams",
    category: "Tips & Guides",
    image: BG5,
  },
   {
    id: 7,
    title: "Introduction to Artificial Intelligence for Kids",
    date: "January 8, 2025",
    readTime: "9 min read",
    excerpt:
    "AI is everywhere! Learn how kids can start understanding artificial intelligence through fun projects, games, and interactive learning experiences designed for young minds.",
    author: "Robert Taylor",
    category: "Science",
    image: BG6,
  },
   {
    id: 7,
    title: "Introduction to Artificial Intelligence for Kids",
    date: "January 8, 2025",
    readTime: "9 min read",
    excerpt:
    "AI is everywhere! Learn how kids can start understanding artificial intelligence through fun projects, games, and interactive learning experiences designed for young minds.",
    author: "Robert Taylor",
    category: "Science",
    image: BG6,
  },
];

const Badge = ({ text }) => (
  <span className="inline-block rounded-full bg-[#FF6636] px-3 py-1 text-sm font-semibold text-white">
    {text}
  </span>
);

const Card = ({ post }) => (
  <article className="rounded-2xl overflow-hidden bg-white  shadow-[0_10px_15px_-5px_#0000001A]">
    <div className="relative ">
      <img
        src={post.image}
        alt={post.title}
        className="h-56 w-full object-cover"
      />
      <div className="absolute left-4 top-4">
        <Badge text={post.category} />
      </div>
    </div>

    <div className="pt-6 px-4 lg:px-6 pb-6 lg:pb-8">
      <div className="flex items-center gap-4 text-sm text-[#6B7280]">
        <div className="flex items-center gap-2">
          <Calender />
          <p>{post.date}</p>
        </div>
        <div className="flex items-center gap-2">
          <Clock />
          <p>{post.readTime}</p>
        </div>
      </div>

      <h3 className="mt-4 text-xl font-bold text-[#1F2937]">{post.title}</h3>
      <p className="mt-6 h-[84px] overflow-y-auto border-b border-[#F3F4F6] pb-4 leading-[26px] text-[#4B5563]">{post.excerpt}</p>

      <div className="mt-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center text-xs font-semibold text-[#374151]">
            {post.author
              .split(" ")
              .map((n) => n[0])
              .slice(0, 2)
              .join("")}
          </div>
          <div className="text-sm font-medium text-[#374151]">
            {post.author}
          </div>
        </div>

        <Link
          // to={`/blog/${post.id}`}
          className="text-sm font-semibold text-[#F97316]"
        >
          Read More →
        </Link>
      </div>
    </div>
  </article>
);

const RecentArticles = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredPosts = selectedCategory === "All" 
    ? posts 
    : posts.filter(post => post.category === selectedCategory);

  return (
    <section className="bg-transparent px-4 pt-11 pb-24 md:pb-32 xl:pb-44 2xl:pb-52">
      <div className="mx-auto max-w-[1700px]">
        <h2 className="text-[40px] leading-[47px] font-bold text-black">
          Recent Articles
        </h2>

        <div className="hidden mt-2 sm:flex gap-3 pb-4 border-b border-[#E5E7EB]">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setSelectedCategory(c)}
              className={`rounded-full px-5 py-2 text-base transition-colors ${
                c === selectedCategory 
                  ? "bg-[#923D8C] text-white" 
                  : "bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-7 grid gap-6 lg:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {filteredPosts.map((post) => (
            <Card post={post} key={post.id} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentArticles;
